import React, { useRef, useEffect, useState } from 'react';
import validationAuth from '../../validationAuth';
import {
    Container, Table, TableBody, TableCell, TableRow, Paper, Button,
    Typography, Radio, TextField, TableContainer, Box, IconButton, TableHead,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import * as common from '../../commons/common';
//import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import iconEdit from '../../images/icon_edit.png';
import RemoveIcon from '@mui/icons-material/Remove';
import useScrolling from './useScrolling';
import { useLocation } from 'react-router-dom';
import leftArrowIcon from '../../images/left_arrow_icon.svg';

//점검 작성 페이지
function RegisterCheck() {
    const navigate = useNavigate();
    const location = useLocation();
    const cellRef = useRef(null);
    const isScrolling = useScrolling()

    const { facilityId } = useParams(); // useParams를 사용해 URL에서 facilityId를 직접 가져옴
    const { checkRsltMstrId } = location.state || {}; // 수정 모드일 때 전달받는 점검 결과 마스터 ID

    const [facilityName, setFacilityName] = useState(''); //시설명
    const [checkStateList, setCheckStateList] = useState([]); //점검상태값 리스트(ex정상/고장)
    const [checkItems, setCheckItems] = useState([]); //점검유형,항목set 리스트
    const [selectedState, setSelectedState] = useState({}); // 선택 점검상태값
    const [rm, setRm] = useState(''); // 비고

    const [facilityPosition, setFacilityPosition] = useState({ latitude: null, longitude: null }); //시설 좌표
    const [currentPosition, setCurrentPosition] = useState({ latitude: null, longitude: null }); //점검자 현재 위치좌표
    const [range, setRange] = useState(0); //위치 허용 반경

    // GPS 상태를 하나의 객체로 통합 관리
    const [gpsStatus, setGpsStatus] = useState({
        isReady: false,           // GPS 준비 완료 여부
        attemptCount: 0,          // 제출 시도 횟수
        loadingMessage: '',       // 로딩 메시지
        lastErrorType: null,      // 마지막 에러 타입 ('gps_fail', 'distance_fail', null)
        errorCode: null           // GPS 에러 코드 ('OUT_OF_RANGE', 'PERMISSION_DENIED', 'NO_SIGNAL', null)
    });

    const [isSubmitting, setIsSubmitting] = useState(false); // 추가 개선사항
    const [expandedItems, setExpandedItems] = useState({});
    const [checkerNm, setCheckerNm] = useState('') //(점검자명 수정 가능하도록)
    const [files, setFiles] = useState([]); //이미지or동영상 파일 첨부
    const [isQr, setIsQr] = useState(false);
    const [summitLoading, setSummitLoading] = useState(false);

    const [status, setLoading] = useState("");
    const [isFacilityLoaded, setIsFacilityLoaded] = useState(false);

    // 최근 점검 결과를 저장할 상태 추가
    const [latestCheckResult, setLatestCheckResult] = useState(null);

    // 수정 모드에서 상세 항목 ID 보관
    const [editDetails, setEditDetails] = useState([]);

    //시작 종료 버튼
    //const [isCheckStarted, setIsCheckStarted] = useState(false);
    //const [checkStartTime, setCheckStartTime] = useState(null);
    //const [checkEndTime, setCheckEndTime] = useState(null);

    //const [useStrBtn, setUseStrBtn] = useState('N'); // 기본값은 'N'으로 설정

    // 시작 버튼만 사용하도록 상태 변수 수정
    //const [isCheckStarted, setIsCheckStarted] = useState(true); // 기본적으로 시작된 상태로 설정
    //const [checkStartTime, setCheckStartTime] = useState(new Date()); // 기본값으로 현재 시간 설정
    // 종료 시간은 항상 현재 시간으로 설정 (사용하지 않음)
    //const [checkEndTime] = useState(new Date());

    // 시작 버튼만 사용하도록 상태 변수 수정
    const [isCheckStarted, setIsCheckStarted] = useState(() => {
        // sessionStorage에서 저장된 값 복원
        const saved = sessionStorage.getItem(`checkStarted_${facilityId}`);
        return saved === 'true';
    });

    const [checkStartTime, setCheckStartTime] = useState(() => {
        // sessionStorage에서 저장된 시간 복원
        const saved = sessionStorage.getItem(`checkStartTime_${facilityId}`);
        return saved ? new Date(saved) : null;
    });

    const [checkEndTime] = useState(new Date());

    const [useStrBtn, setUseStrBtn] = useState(() => {
        // sessionStorage에서 저장된 값 복원
        const saved = sessionStorage.getItem(`useStrBtn_${facilityId}`);
        return saved || 'N';
    });

    const [locationStatus, setLocationStatus] = useState({
        isLoading: false,
        hasError: false,
        errorMessage: ''
    });

    const [initialLoadings, setInitialLoadings] = useState({
        userData: false,
        checkItems: false
    });

    const ScrollToTop = () => {
        window.scrollTo(0, 0);
    };

    const isFormEnabled = () => {
        // useStrBtn이 'N'이면 항상 활성화, 'Y'이면 isCheckStarted가 true일 때만 활성화
        // 수정 모드(checkRsltMstrId 있음)에서는 시작 버튼이 없으므로 항상 활성화
        return useStrBtn === 'N' || isCheckStarted || !!checkRsltMstrId;
    };

    // 점검 시작 처리
    const handleCheckStart = () => {
        const startTime = new Date();
        setIsCheckStarted(true);
        setCheckStartTime(startTime);

        // sessionStorage에 저장
        sessionStorage.setItem(`checkStarted_${facilityId}`, 'true');
        sessionStorage.setItem(`checkStartTime_${facilityId}`, startTime.toISOString());

        alert("점검을 시작합니다.");
    };

    //점검자 이름 가져오기
    useEffect(() => {
        const fetchUserData = async () => {
            const memberId = localStorage.getItem('memberId');
            if (memberId) {
                try {
                    const url = `${common.getApiUrl()}/member/${memberId}`;
                    const accessToken = localStorage.getItem('access_token');
                    const response = await axios.get(url, {
                        headers: {
                            Authorization: `Bearer ${accessToken}`
                        }
                    });
                    setCheckerNm(response.data.memberNm);
                } catch (error) {
                    common.handleApiError(error);
                }
            }
        };
        fetchUserData();
    }, []);

    const calculateDistance = (lat1, lon1, lat2, lon2) => {
        const toRad = (value) => value * Math.PI / 180;
        const R = 6371e3;
        const φ1 = toRad(lat1);
        const φ2 = toRad(lat2);
        const Δφ = toRad(lat2 - lat1);
        const Δλ = toRad(lon2 - lon1);

        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const distance = R * c;
        return distance;
    };

    // latestCheckResult가 변경될 때 상태값 재설정
    useEffect(() => {
        if (latestCheckResult && checkItems.length > 0 && checkStateList.length > 0) {
            console.log("latestCheckResult 변경으로 상태값 재설정 시도");
            console.log("현재 checkStateList:", checkStateList);
            console.log("현재 latestCheckResult:", latestCheckResult);

            const updatedValues = {...selectedState};

            // 각 항목별 상태값 업데이트
            if (Array.isArray(latestCheckResult)) {
                // API 응답이 배열 형태인 경우
                latestCheckResult.forEach(result => {
                    const item = checkItems.find(item => item.checkItemId === result.checkItemId);

                    if (item) {
                        // 텍스트 입력 항목
                        if (item.textYn === "Y") {
                            updatedValues[item.checkItemId] = result.checkRsltValNm || "";
                            console.log(`텍스트 항목 ${item.checkItemId} 값 설정: ${result.checkRsltValNm}`);
                        } else {
                            // 라디오 버튼 항목 - checkRsltValNm으로 직접 설정
                            const stateNm = result.checkRsltValNm;
                            if (stateNm && checkStateList.some(state => state.checkStateNm === stateNm)) {
                                updatedValues[item.checkItemId] = stateNm;
                                console.log(`라디오 항목 ${item.checkItemId} 값 설정: ${stateNm}`);
                            }
                        }

                        // 비고 설정
                        if (result.rm) {
                            updatedValues[`rm_${item.checkItemId}`] = result.rm;
                            console.log(`항목 ${item.checkItemId} 비고 설정: ${result.rm}`);
                        }
                    }
                });

                console.log("최종 업데이트될 상태값:", updatedValues);
                setSelectedState(updatedValues);
            }
        }
    }, [latestCheckResult, checkItems, checkStateList]);

    // 시설 정보 및 점검 항목 가져오기
    useEffect(() => {
        const fetchCheckItems = async () => {
            setIsFacilityLoaded(false); // 로딩 시작

            // GPS 상태 완전 초기화
            setCurrentPosition({ latitude: null, longitude: null });
            setGpsStatus({
                isReady: false,
                attemptCount: 0,
                loadingMessage: '',
                lastErrorType: null,
                errorCode: null
            });

            var id = facilityId;
            var qrEnter = false;

            // 점검자 qr로 접속시(qrUUID 값을 가지고 있는경우)
            if (!Number(facilityId)) {
                try {
                    const response = await axios.get(`${common.getApiUrl()}/checker/facility/${facilityId}`, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            'Content-Type': 'application/json',
                        },
                    });
                    const facilityData = response.data.data;
                    if (facilityData) {
                        id = facilityData.facilityId;
                        setIsQr(true);
                    }
                } catch (error) {
                    alert('해당 시설의 점검자가 아닙니다.')
                    navigate(`/checker`);
                }
            } else {
                try { //qr 점검시설을 url로 접속 시 돌려보내기
                    const response = await axios.get(`${common.getApiUrl()}/checker/${facilityId}`, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        if (response.data.qrYn === 'Y') {
                            alert('해당 시설은 QR접속 점검만 가능합니다.')
                            navigate(`/checker`);
                        }
                    }
                } catch (error) {
                    alert('잘못된 접근입니다.')
                    navigate(`/checker`);
                }
            }

            try {
                // 수정 모드: 특정 점검 기록 로드 / 일반 모드: 최근 점검 결과 로드
                if (checkRsltMstrId) {
                    try {
                        const detailResponse = await axios.get(`${common.getApiUrl()}/checker/result/detail/${checkRsltMstrId}`, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                                'Content-Type': 'application/json',
                            },
                        });
                        const details = detailResponse.data.checkRsltDtlRes || [];
                        setEditDetails(details);
                        setLatestCheckResult(details);
                        if (details.length > 0 && details[0].mstrRm) {
                            setRm(details[0].mstrRm);
                        }
                    } catch (error) {
                        console.log('점검 상세 데이터를 가져오는데 실패했습니다:', error);
                        setLatestCheckResult(null);
                    }
                } else {
                    // 최근 점검 결과 가져오기 시도 부분을 수정
                    try {
                        const latestResultResponse = await axios.get(`${common.getApiUrl()}/checker/result/latest/${id}`, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                                'Content-Type': 'application/json',
                            },
                        });

                        console.log("API 응답 전체:", latestResultResponse.data);

                        if (latestResultResponse.data &&
                            (Array.isArray(latestResultResponse.data) ? latestResultResponse.data.length > 0 : true)) {
                            // 유효한 데이터가 있는 경우에만 설정
                            setLatestCheckResult(latestResultResponse.data);

                            // 배열인 경우 직접 처리
                            if (Array.isArray(latestResultResponse.data)) {
                                console.log("체크 항목 개수:", latestResultResponse.data.length);
                                if (latestResultResponse.data.length > 0) {
                                    console.log("첫 번째 체크 항목:", latestResultResponse.data[0]);
                                    // 첫 번째 항목의 mstrRm 값을 비고란에 설정
                                    if (latestResultResponse.data[0].mstrRm) {
                                        setRm(latestResultResponse.data[0].mstrRm);
                                    }
                                }
                            } else {
                                // 객체인 경우 기존 처리 유지
                                console.log("점검자명:", latestResultResponse.data.checkerNm);
                                console.log("전체 비고:", latestResultResponse.data.rm);

                                // 객체에 rm 값이 있으면 해당 값을 비고란에 설정
                                if (latestResultResponse.data.rm) {
                                    setRm(latestResultResponse.data.rm);
                                }

                                if (latestResultResponse.data.checkRsltDtls) {
                                    console.log("체크 항목 개수:", latestResultResponse.data.checkRsltDtls.length);
                                    console.log("첫 번째 체크 항목:", latestResultResponse.data.checkRsltDtls[0]);

                                    // 첫 번째 항목의 mstrRm 값을 비고란에 설정 (rm 값이 없는 경우)
                                    if (!latestResultResponse.data.rm &&
                                        latestResultResponse.data.checkRsltDtls.length > 0 &&
                                        latestResultResponse.data.checkRsltDtls[0].mstrRm) {
                                        setRm(latestResultResponse.data.checkRsltDtls[0].mstrRm);
                                    }
                                }
                            }
                        } else {
                            console.log("최근 점검 결과가 없습니다.");
                            setLatestCheckResult(null);
                        }
                    } catch (error) {
                        console.log('최근 점검 결과를 가져오는데 실패했습니다:', error);
                        setLatestCheckResult(null);
                    }
                } // end of else (일반 모드)

                const responseFacilityInfo = await axios.get(`${common.getApiUrl()}/checker/${id}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (responseFacilityInfo.data.facilityNm) setFacilityName(responseFacilityInfo.data.facilityNm);

                if (responseFacilityInfo.data.gpsRadius !== undefined && responseFacilityInfo.data.gpsRadius !== null) {
                    setRange(parseFloat(responseFacilityInfo.data.gpsRadius));
                    console.log("GPS 반경 설정:", responseFacilityInfo.data.gpsRadius, "m");
                }

                const params = {
                    facilityTypeId: responseFacilityInfo.data.facilityTypeId
                }

                // 시설 정보 가져올 때 useStrBtn 값 설정
                if (responseFacilityInfo.data.useStrBtn) {
                    setUseStrBtn(responseFacilityInfo.data.useStrBtn);
                    // sessionStorage에 저장
                    sessionStorage.setItem(`useStrBtn_${facilityId}`, responseFacilityInfo.data.useStrBtn);

                    // useStrBtn이 'Y'이면 isCheckStarted를 false로 초기화
                    if (responseFacilityInfo.data.useStrBtn === 'Y') {
                        // sessionStorage에 저장된 값이 없을 때만 초기화
                        const savedStarted = sessionStorage.getItem(`checkStarted_${facilityId}`);
                        if (!savedStarted) {
                            setIsCheckStarted(false);
                            setCheckStartTime(null);
                        }
                    }
                }

                if (responseFacilityInfo.data.checkItems && Array.isArray(responseFacilityInfo.data.checkItems)) {
                    setCheckItems(responseFacilityInfo.data.checkItems);
                    const checkState = await axios.get(`${common.getApiUrl()}/facility-type/check-state`, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            'Content-Type': 'application/json',
                        },
                        params
                    });

                    setCheckStateList(
                        checkState.data.map(item => ({
                            checkStateId: item.facilityTypeCheckStateId,
                            checkStateNm: item.checkStateNm,
                        }))
                    );

                    // 초기 상태값 설정 수정
                    const defaultValue = {};

// 기본값 설정 - 모든 항목에 대해 먼저 기본값 설정
                    responseFacilityInfo.data.checkItems.forEach(item => {
                        if (item.textYn === "Y") {
                            defaultValue[item.checkItemId] = "";
                        } else {
                            defaultValue[item.checkItemId] = checkState.data[0].checkStateNm;
                        }
                    });

// 최근 데이터가 있는 경우에만 덮어쓰기
                    if (latestCheckResult) {
                        if (Array.isArray(latestCheckResult) && latestCheckResult.length > 0) {
                            // API 응답이 배열인 경우
                            latestCheckResult.forEach(result => {
                                const item = responseFacilityInfo.data.checkItems.find(item => item.checkItemId === result.checkItemId);

                                if (item) {
                                    // 텍스트 입력 항목
                                    if (item.textYn === "Y") {
                                        defaultValue[item.checkItemId] = result.checkRsltValNm || "";
                                        console.log(`텍스트 항목 ${item.checkItemId} 초기값 설정: ${result.checkRsltValNm}`);
                                    } else {
                                        // 라디오 버튼 항목 - checkRsltValNm으로 직접 설정
                                        const stateNm = result.checkRsltValNm;
                                        if (stateNm && checkState.data.some(state => state.checkStateNm === stateNm)) {
                                            defaultValue[item.checkItemId] = stateNm;
                                            console.log(`라디오 항목 ${item.checkItemId} 초기값 설정: ${stateNm}`);
                                        }
                                    }

                                    // 비고 설정
                                    if (result.rm) {
                                        defaultValue[`rm_${item.checkItemId}`] = result.rm;
                                        console.log(`항목 ${item.checkItemId} 비고 초기값 설정: ${result.rm}`);
                                    }
                                }
                            });
                        } else if (latestCheckResult.checkRsltDtls && Array.isArray(latestCheckResult.checkRsltDtls) && latestCheckResult.checkRsltDtls.length > 0) {
                            // 객체 안에 배열이 있는 경우
                            latestCheckResult.checkRsltDtls.forEach(result => {
                                const item = responseFacilityInfo.data.checkItems.find(item => item.checkItemId === result.checkItemId);

                                if (item) {
                                    console.log(`항목 ${item.checkItemId}의 최근 결과:`, result);

                                    // 텍스트 입력 항목
                                    if (item.textYn === "Y") {
                                        defaultValue[item.checkItemId] = result.checkRsltValNm || "";
                                        console.log(`텍스트 항목 ${item.checkItemId} 초기값 설정: ${result.checkRsltValNm}`);
                                    } else {
                                        // 라디오 버튼 항목 처리
                                        if (result.checkRsltVal) {
                                            // checkRsltVal이 있으면 ID로 찾기
                                            const checkStateId = result.checkRsltVal;
                                            const matchingState = checkState.data.find(state =>
                                                state.facilityTypeCheckStateId == checkStateId
                                            );

                                            if (matchingState) {
                                                defaultValue[item.checkItemId] = matchingState.checkStateNm;
                                                console.log(`항목 ${item.checkItemId} 라디오 값 설정: ${matchingState.checkStateNm} (ID: ${checkStateId})`);
                                            } else {
                                                console.log(`항목 ${item.checkItemId}에 대한 상태 ID ${checkStateId}와 일치하는 상태를 찾을 수 없습니다.`);
                                            }
                                        } else if (result.checkRsltValNm) {
                                            // checkRsltValNm으로 직접 설정
                                            const stateNm = result.checkRsltValNm;
                                            if (checkState.data.some(state => state.checkStateNm === stateNm)) {
                                                defaultValue[item.checkItemId] = stateNm;
                                                console.log(`항목 ${item.checkItemId} 라디오 값 설정: ${stateNm}`);
                                            }
                                        }
                                    }

                                    // 비고 설정
                                    if (result.rm) {
                                        defaultValue[`rm_${item.checkItemId}`] = result.rm;
                                        console.log(`항목 ${item.checkItemId} 비고 설정:`, result.rm);
                                    }
                                }
                            });
                        } else {
                            console.log("최근 점검 결과가 없거나 형식이 다릅니다. 기본값을 사용합니다.");
                        }
                    }

                    console.log("최종 설정될 상태값:", defaultValue);
                    setSelectedState(defaultValue);
                } else {
                    setCheckItems([]);
                }
                if (responseFacilityInfo.data && responseFacilityInfo.data.latitude && responseFacilityInfo.data.longitude) {
                    setFacilityPosition({
                        latitude: parseFloat(responseFacilityInfo.data.latitude),
                        longitude: parseFloat(responseFacilityInfo.data.longitude),
                    });
                }

                setIsFacilityLoaded(true);
                setInitialLoadings(prev => ({ ...prev, checkItems: true }));
            } catch (error) {
                common.handleApiError(error);
                navigate(`/checker`);
            }
        };
        ScrollToTop()
        fetchCheckItems();
    }, [facilityId]);

    const requestLocationAccess = async (maxRetries = 2, showAlerts = false, isRetry = false) => {
        if (locationStatus.isLoading) return { success: false, position: null };

        setLocationStatus({ isLoading: true, hasError: false, errorMessage: '' });

        if (showAlerts) {
            setGpsStatus(prev => ({ ...prev, loadingMessage: 'GPS 위치를 확인하는 중입니다...' }));
        } else {
            setGpsStatus(prev => ({ ...prev, loadingMessage: '위치 정보 확인 중...' }));
        }

        const actualRetries = isRetry ? 1 : maxRetries;

        for (let attempt = 1; attempt <= actualRetries; attempt++) {
            try {
                const options = {
                    enableHighAccuracy: (showAlerts || isRetry),
                    timeout: (showAlerts || isRetry) ? 20000 : 10000,
                    maximumAge: (showAlerts || isRetry) ? 0 : 60000
                    //enableHighAccuracy: attempt > 1 || isRetry,
                    //timeout: 10000 + (attempt * 5000),
                    //maximumAge: attempt === 1 ? 300000 : 0  // 첫 시도는 캐시 허용, 재시도는 새로 가져오기
                };

                const position = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject, options);
                });

                const accuracy = position.coords.accuracy;

                // 제출 시 정확도 체크 추가
                if ((showAlerts || isRetry) && accuracy > 100) {
                    console.warn(`⚠️ GPS 정확도 낮음: ${accuracy}m (시도 ${attempt}/${actualRetries})`);

                    if (attempt < actualRetries) {
                        console.log("정확도 낮아서 재시도...");
                        await new Promise(r => setTimeout(r, 2000));  // 2초 대기
                        continue;
                    }

                    // ⭐ 마지막 시도에서도 정확도 낮으면 경고
                    if (showAlerts && accuracy > 200) {
                        console.warn(`⚠️ 최종 GPS 정확도 매우 낮음: ${accuracy}m`);
                    }
                }

                console.log("GPS 위치 획득 성공:", {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: `${accuracy}m`,
                    timestamp: new Date().toISOString(),
                    attempt,
                    mode: showAlerts ? '제출모드' : '프리로딩'
                });

                const coords = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                };

                setCurrentPosition(coords);
                setLocationStatus({ isLoading: false, hasError: false, errorMessage: '' });
                setGpsStatus(prev => ({
                    ...prev,
                    isReady: true,
                    loadingMessage: '',
                    lastErrorType: null,
                    errorCode: null,
                    attemptCount: 0
                }));

                // 테스트용 알림 주석처리
                // if (showAlerts && isRetry) {
                //     alert(`✅ GPS 위치를 성공적으로 확인했습니다.`);
                // }

                return { success: true, position: coords };

            } catch (error) {
                console.error(`GPS 시도 ${attempt}/${actualRetries} 실패:`, error);
                console.log('에러 상세:', error.code, error.message);

                // 재시도 시 (2차 실패)
                if (isRetry) {
                    let errorCode = 'NO_SIGNAL';
                    let finalMessage = '';

                    if (error.code === 1) {
                        errorCode = 'PERMISSION_DENIED';
                        // 2차 권한 거부 메시지 수정
                        finalMessage = 'GPS 위치 권한이 거부되었습니다.\nGPS 권한 다시 확인해주세요 (2/2)';
                    } else if (error.code === 2 || error.code === 3) {
                        errorCode = 'NO_SIGNAL';
                        finalMessage = 'GPS 신호를 받을 수 없습니다.\n다시 시도해주세요 (2/2)';
                    } else {
                        errorCode = 'NO_SIGNAL';
                        finalMessage = 'GPS를 확인할 수 없습니다.\n다시 시도해주세요 (2/2)';
                    }

                    if (showAlerts) {
                        alert(finalMessage);
                    }

                    setLocationStatus({
                        isLoading: false,
                        hasError: true,
                        errorMessage: error.message
                    });

                    setGpsStatus(prev => ({
                        ...prev,
                        isReady: false,
                        loadingMessage: 'GPS 확인이 되지않습니다. 강제 점검으로 진행합니다.',
                        lastErrorType: 'gps_fail',
                        errorCode: errorCode,
                        attemptCount: 2
                    }));

                    console.log(`GPS 최종 실패 - 에러 코드: ${errorCode} (error.code: ${error.code})`);
                    return { success: false, position: null };
                }

                // 첫 시도 실패 (1차 실패)
                if (attempt >= actualRetries) {
                    if (showAlerts) {
                        let retryMessage = '';
                        if (error.code === 1) {
                            // 1차 권한 거부 메시지 수정
                            retryMessage = 'GPS 위치 권한이 필요합니다.\nGPS 설정 권한 열고 다시 시도해주세요 (1/2)';
                        } else {
                            retryMessage = 'GPS 신호를 받을 수 없습니다.\n다시 시도해주세요 (1/2)';
                        }
                        alert(retryMessage);
                    }

                    setLocationStatus({
                        isLoading: false,
                        hasError: true,
                        errorMessage: error.message
                    });

                    setGpsStatus(prev => ({
                        ...prev,
                        isReady: true,
                        loadingMessage: '',
                        lastErrorType: 'gps_fail',
                        errorCode: null,
                        attemptCount: 1
                    }));

                    console.log(`GPS 첫 실패 - 사용자에게 재시도 기회 제공`);
                    return { success: false, position: null };
                }
            }
        }
        return { success: false, position: null };
    };

    // const requestLocationAccess = async () => {
    //     if (locationStatus.isLoading) return;
    //
    //     setLocationStatus({ isLoading: true, hasError: false, errorMessage: '' });
    //     setLoading("Locating…");
    //
    //     try {
    //         const position = await new Promise((resolve, reject) => {
    //             if ("geolocation" in navigator) {
    //                 navigator.geolocation.getCurrentPosition(
    //                     (position) => resolve(position),
    //                     (error) => reject(error),
    //                     //{ enableHighAccuracy: true }
    //                     {
    //                         enableHighAccuracy: false,  // 정확도 낮춤 (더 빠름)
    //                         timeout: 15000,             // 15초로 늘림
    //                         maximumAge: 60000           // 1분간 캐시된 위치 사용 허용
    //                     }
    //                 );
    //             } else {
    //                 reject(new Error("위치 기반을 지원하지 않는 브라우저입니다."));
    //             }
    //         });
    //
    //         setCurrentPosition({
    //             latitude: position.coords.latitude,
    //             longitude: position.coords.longitude
    //         });
    //         setLocationStatus({ isLoading: false, hasError: false, errorMessage: '' });
    //         setInitialLoadings(prev => ({ ...prev, location: true }));
    //         return true;
    //     } catch (error) {
    //         setLocationStatus({
    //             isLoading: false,
    //             hasError: true,
    //             errorMessage: error.message
    //         });
    //         return false;
    //     }
    // };

    // 상태값 변경마다 전체값 체크되었는지 확인 - '작성완료' 버튼활성화
    useEffect(() => {
        const allChecked = areAllItemsChecked();
        const buttonElement = document.getElementById("submitButton");

        if (buttonElement) {
            const hasValidFacilityLocation = facilityPosition.latitude && facilityPosition.longitude;
            const shouldCheckGPS = hasValidFacilityLocation && !isQr;

            // ⭐ errorCode가 있으면 강제 모드로 준비 완료
            const isGpsReady = !shouldCheckGPS || gpsStatus.isReady || gpsStatus.errorCode;

            const isButtonEnabled = allChecked && isGpsReady && !isSubmitting;

            buttonElement.style.backgroundColor = isButtonEnabled ? 'var(--main-blue-color)' : '#e0e0e0';
            buttonElement.disabled = !isButtonEnabled;
        }
    }, [selectedState, checkEndTime, gpsStatus, isSubmitting, facilityPosition, isQr]);

    // GPS 프리로딩 - 시설 정보 로드 후 한 번만 실행
    useEffect(() => {
        const preloadLocation = async () => {
            if ("geolocation" in navigator && facilityPosition.latitude && facilityPosition.longitude) {
                setGpsStatus(prev => ({ ...prev, loadingMessage: '위치 정보 준비 중...' }));

                try {
                    const position = await new Promise((resolve, reject) => {
                        navigator.geolocation.getCurrentPosition(
                            resolve,
                            reject,
                            {
                                enableHighAccuracy: false,
                                timeout: 15000,
                                maximumAge: 300000  // 5분(300초) 캐시 허용
                            }
                        );
                    });

                    console.log("GPS 프리로딩 성공:", {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });

                    setCurrentPosition({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });
                    setGpsStatus(prev => ({
                        ...prev,
                        isReady: true,
                        loadingMessage: '',
                        lastErrorType: null,
                        errorCode: null
                    }));
                } catch (error) {
                    console.error("GPS 프리로딩 실패:", error);

                    setGpsStatus(prev => ({
                        ...prev,
                        isReady: true,
                        loadingMessage: '',
                        lastErrorType: null,
                        errorCode: null
                    }));

                    console.log(`GPS 프리로딩 실패 - 제출 시 재시도 예정`);
                }
            } else if (!facilityPosition.latitude || !facilityPosition.longitude) {
                setGpsStatus(prev => ({
                    ...prev,
                    isReady: true,
                    loadingMessage: '',
                    errorCode: null
                }));
            }
        };

        if (isFacilityLoaded) {
            preloadLocation();
        }
    }, [isFacilityLoaded, facilityPosition.latitude, facilityPosition.longitude]);

    // GPS 프리로딩 useEffect
    // useEffect(() => {
    //     const preloadLocation = async () => {
    //         if ("geolocation" in navigator && facilityPosition.latitude && facilityPosition.longitude) {
    //             setGpsLoadingStatus('위치 정보 준비 중...');
    //             try {
    //                 const position = await new Promise((resolve, reject) => {
    //                     navigator.geolocation.getCurrentPosition(
    //                         resolve,
    //                         reject,
    //                         {
    //                             enableHighAccuracy: false,
    //                             timeout: 20000,
    //                             maximumAge: 300000
    //                         }
    //                     );
    //                 });
    //
    //                 setCurrentPosition({
    //                     latitude: position.coords.latitude,
    //                     longitude: position.coords.longitude
    //                 });
    //                 setGpsReady(true);
    //                 setGpsLoadingStatus('');
    //                 setIsForceMode(false);
    //                 console.log("GPS 프리로딩 성공");
    //             } catch (error) {
    //                 console.log("GPS 프리로딩 실패, 강제 모드로 전환");
    //                 setGpsReady(false);
    //                 setIsForceMode(true);
    //
    //                 // 프리로딩 실패 시에도 강제 모드 메시지 표시
    //                 if (error.code === 1 || error.code === 2 || error.code === 3) {
    //                     setGpsLoadingStatus('GPS 확인이 되지않습니다. 강제 점검으로 진행합니다.');
    //                 } else {
    //                     setGpsLoadingStatus('GPS 확인이 되지않습니다. 강제 점검으로 진행합니다.');
    //                 }
    //             }
    //         } else if (!facilityPosition.latitude || !facilityPosition.longitude) {
    //             // QR 접속이거나 시설 위치가 없는 경우 GPS 체크 불필요
    //             setGpsReady(true);
    //             setGpsLoadingStatus('');
    //             setIsForceMode(false);
    //         }
    //     };
    //
    //     // 시설 정보 로드 후 GPS 프리로딩 실행
    //     if (isFacilityLoaded) {
    //         preloadLocation();
    //     }
    // }, [isFacilityLoaded, facilityPosition]);


    const handleRadioChange = (id) => (event) => {
        setSelectedState({ ...selectedState, [id]: event.target.value });
    };

    const handleTextChange = (id) => (event) => {
        setSelectedState({ ...selectedState, [id]: event.target.value });
    };

    // 각 점검항목 파일 업로드
    const handleEachStateImgUpload = (item, event) => {
        // 파일 입력값 초기화를 위해 이벤트 타겟 저장
        const fileInput = event.target;
        const uploadedFiles = Array.from(event.target.files);
        const filePreviews = uploadedFiles.map(file => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setSelectedState(prev => ({
            ...prev,
            [`uploadFiles_${item.checkItemId}`]: [
                ...(prev[`uploadFiles_${item.checkItemId}`] || []),
                ...uploadedFiles
            ],
            [`filePreviews_${item.checkItemId}`]: [
                ...(prev[`filePreviews_${item.checkItemId}`] || []),
                ...filePreviews
            ],
        }));

        // 파일 입력값 초기화
        fileInput.value = '';
    };

    // 각 항목 파일 삭제
    const handleEachStateImgRemove = (item, index) => {
        setSelectedState(prevState => {
            const updatedFiles = prevState[`uploadFiles_${item.checkItemId}`].filter((_, i) => i !== index);
            const updatedPreviews = prevState[`filePreviews_${item.checkItemId}`].filter((_, i) => i !== index);

            // URL.revokeObjectURL을 사용하여 메모리 누수 방지
            if (prevState[`filePreviews_${item.checkItemId}`][index]) {
                URL.revokeObjectURL(prevState[`filePreviews_${item.checkItemId}`][index].preview);
            }

            return {
                ...prevState,
                [`uploadFiles_${item.checkItemId}`]: updatedFiles,
                [`filePreviews_${item.checkItemId}`]: updatedPreviews,
            };
        });
    };

    // 파일 업로드
    const handleFileUpload = (event) => {
        // 파일 입력값 초기화를 위해 이벤트 타겟 저장
        const fileInput = event.target;
        const uploadedFiles = Array.from(event.target.files);
        const filePreviews = uploadedFiles.map(file => ({
            file,
            preview: URL.createObjectURL(file),
        }));
        setFiles((prevFiles) => [...prevFiles, ...filePreviews]);

        // 파일 입력값 초기화
        fileInput.value = '';
    };

    // 파일 삭제
    const handleFileRemove = (index) => {
        setFiles((prevFiles) => {
            // URL.revokeObjectURL을 사용하여 메모리 누수 방지
            if (prevFiles[index]) {
                URL.revokeObjectURL(prevFiles[index].preview);
            }
            return prevFiles.filter((_, i) => i !== index);
        });
    };

    const areAllItemsChecked = () => {
        return checkItems.every(item => {
            const value = selectedState[item.checkItemId];
            return value !== '' && value !== undefined && value !== null;
        });
    };

    const submitResults = async () => {
        if (!isFacilityLoaded) {
            alert("시설 정보를 불러오는 중입니다.");
            return;
        }

        if (!checkerNm || checkerNm.trim() === '') {
            alert("점검자명을 입력해주세요.");
            return;
        }

        // 수정 모드: PUT API 호출
        if (checkRsltMstrId) {
            if (!areAllItemsChecked()) {
                alert("모든 점검 항목을 작성해주세요.");
                return;
            }
            if (isSubmitting) return;
            setIsSubmitting(true);
            try {
                const token = localStorage.getItem('access_token');
                const formData = new FormData();
                const checkRsltDtls = checkItems.map(item => {
                    const existing = editDetails.find(d => d.checkItemId === item.checkItemId);
                    const selectedHeader = checkStateList.find(s => s.checkStateNm === selectedState[item.checkItemId]);
                    return {
                        checkRsltDtlId: existing?.checkRsltDtlId || 0,
                        checkItemId: item.checkItemId,
                        checkItemNm: item.checkItemNm,
                        checkRsltVal: item.textYn === 'Y' ? '' : (selectedHeader ? selectedHeader.checkStateId : ''),
                        checkRsltValNm: selectedState[item.checkItemId] || '',
                        rm: selectedState[`rm_${item.checkItemId}`] || '',
                    };
                });
                // const modifiedCheckRsltRequest = { checkRsltDtls };
                await axios.put(`${common.getApiUrl()}/checker/result/detail`, { checkRsltDtls }, {
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                });
                alert('점검 기록이 수정되었습니다.');
                navigate(-1);
            } catch (error) {
                common.handleApiError(error);
                alert('점검 기록 수정에 실패하였습니다.');
            } finally {
                setIsSubmitting(false);
            }
            return;
        }

        if (!areAllItemsChecked()) {
            alert("모든 점검 항목을 작성해주세요.");
            return;
        }

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        let formData = new FormData();
        const filesWithoutPreview = files.map(fileObj => fileObj.file);

        const hasValidFacilityLocation = facilityPosition.latitude && facilityPosition.longitude;
        const shouldCheckGPS = hasValidFacilityLocation && !isQr;

        let finalGpsStatusCode = null;
        let calculatedDistance = null;
        let positionToUse = currentPosition;

        let gpsValidationResult = {
            success: true,
            reason: null
        };

        // GPS 검증이 필요한 경우
        if (shouldCheckGPS) {

            if (!currentPosition.latitude ||
                !currentPosition.longitude ||
                gpsStatus.lastErrorType === 'distance_fail' ||
                gpsStatus.errorCode) {

                console.log("GPS 위치 확인 시작");

                if (gpsStatus.errorCode) {
                    console.log("⚠️ errorCode 있음 - GPS 재확인 기회 제공");
                } else if (gpsStatus.lastErrorType === 'distance_fail') {
                    console.log("거리 실패 후 재시도 - GPS 위치 재확인");
                } else {
                    console.log("GPS 위치 정보 없음, 재시도 시작");
                }

                const isRetry = gpsStatus.attemptCount >= 1 &&
                    (gpsStatus.lastErrorType === 'gps_fail' ||
                        gpsStatus.lastErrorType === 'distance_fail' ||
                        gpsStatus.errorCode);

                // 3차 시도(attemptCount >= 2이고 errorCode 있음)에서는 알림 표시 안 함
                const showAlertsForRetry = !(gpsStatus.attemptCount >= 2 && gpsStatus.errorCode);

                const locationResult = await requestLocationAccess(2, showAlertsForRetry, isRetry);

                if (!locationResult.success) {
                    if (gpsStatus.attemptCount >= 2 && gpsStatus.errorCode) {
                        // 강제 등록 진행
                        gpsValidationResult = { success: false, reason: 'gps_unavailable' };
                        finalGpsStatusCode = gpsStatus.errorCode;
                        console.log(`GPS 검증 최종 실패 (${gpsStatus.attemptCount}차) - 에러 코드: ${finalGpsStatusCode}`);
                    } else {
                        // 제출 중단
                        console.log(`GPS ${gpsStatus.attemptCount}차 실패 - 제출 중단, 재시도 대기`);
                        setIsSubmitting(false);
                        return;
                    }
                } else {
                    positionToUse = locationResult.position;
                    setCurrentPosition(positionToUse);
                    console.log("✅ GPS 위치 확인 성공:", positionToUse);
                }
            }

            // 거리 검증
            if (gpsValidationResult.success && positionToUse && positionToUse.latitude && positionToUse.longitude) {
                const distance = calculateDistance(
                    positionToUse.latitude,
                    positionToUse.longitude,
                    facilityPosition.latitude,
                    facilityPosition.longitude
                );

                calculatedDistance = distance;

                console.log('=== GPS 검증 정보 ===');
                console.log('현재 위치 - 위도:', positionToUse.latitude, '경도:', positionToUse.longitude);
                console.log('시설 위치 - 위도:', facilityPosition.latitude, '경도:', facilityPosition.longitude);
                console.log('계산된 거리:', distance.toFixed(2), 'm');
                console.log('허용 반경:', range, 'm');
                console.log('==================');

                if (typeof distance === 'number' && !isNaN(distance)) {
                    if (distance > range) {
                        // ⭐ 거리 검증 실패 - 최종 결과 설정
                        gpsValidationResult = { success: false, reason: 'out_of_range' };
                        finalGpsStatusCode = 'OUT_OF_RANGE';

                        if (gpsStatus.attemptCount === 0 || gpsStatus.lastErrorType !== 'distance_fail') {
                            // 1차 거리 실패
                            setGpsStatus(prev => ({
                                ...prev,
                                attemptCount: 1,
                                lastErrorType: 'distance_fail',
                                errorCode: null
                            }));
                            setIsSubmitting(false);

                            const locationInfo = `거리검증 실패 (1/2)\n\n` +
                                `시설물 반경 ${range}m 이내에서\n다시 시도해주세요.`;

                            alert(locationInfo);
                            return;
                        } else if (gpsStatus.attemptCount === 1 && gpsStatus.lastErrorType === 'distance_fail') {
                            // 2차 거리 실패 - 강제 등록 진행
                            setGpsStatus(prev => ({
                                ...prev,
                                attemptCount: 2,
                                errorCode: 'OUT_OF_RANGE'
                            }));
                            console.log("거리 2차 실패 - 강제 등록 진행, finalGpsStatusCode:", finalGpsStatusCode);
                        }
                    } else {
                        // ⭐ 거리 검증 성공 - 이전 실패 이력과 무관하게 무조건 성공 처리
                        gpsValidationResult = { success: true, reason: null };
                        finalGpsStatusCode = null;  // ⭐ 무조건 null로 설정

                        console.log("✅ 거리 검증 성공 - GPS 정상 (이전 실패 이력 무시)");

                        // 상태 초기화
                        setGpsStatus(prev => ({
                            ...prev,
                            attemptCount: 0,
                            lastErrorType: null,
                            errorCode: null
                        }));
                    }
                }
            }

            // 강제 모드에서 거리 계산
            if (calculatedDistance === null && currentPosition.latitude && currentPosition.longitude) {
                calculatedDistance = calculateDistance(
                    positionToUse.latitude,
                    positionToUse.longitude,
                    facilityPosition.latitude,
                    facilityPosition.longitude
                );
                console.log('강제 모드에서 거리 계산:', calculatedDistance.toFixed(2), 'm');
            }
        }

        // 시간 포맷팅
        const formatTime = (date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        };

        // 점검 결과 데이터 구성
        const checkRsltDtls = checkItems.map(item => {
            if (item.textYn === "Y") {
                return {
                    checkItemId: item.checkItemId,
                    checkItemNm: item.checkItemNm,
                    checkRsltVal: "",
                    checkRsltValNm: selectedState[item.checkItemId] || "",
                    textYn: item.textYn,
                    rm: selectedState[`rm_${item.checkItemId}`] || "",
                    dtlUploadFiles: selectedState[`uploadFiles_${item.checkItemId}`] || []
                };
            } else {
                const selectedHeader = checkStateList.find(state => state.checkStateNm === selectedState[item.checkItemId]);
                return {
                    checkItemId: item.checkItemId,
                    checkItemNm: item.checkItemNm,
                    checkRsltVal: selectedHeader ? selectedHeader.checkStateId : '',
                    checkRsltValNm: selectedState[item.checkItemId],
                    textYn: item.textYn,
                    rm: selectedState[`rm_${item.checkItemId}`] || "",
                    dtlUploadFiles: selectedState[`uploadFiles_${item.checkItemId}`] || []
                };
            }
        });

        const isGpsSuccess = !shouldCheckGPS || (gpsValidationResult.success && !finalGpsStatusCode);

        let insertCheckRsltRequest = {
            facilityId: facilityId,
            gpsYn: isGpsSuccess ? 'Y' : 'N',
            gpsStatus: isGpsSuccess ? null : (finalGpsStatusCode || 'NO_SIGNAL'),  // 실패 시 무조건 값 있음
            gpsRange: calculatedDistance !== null ? parseFloat(calculatedDistance.toFixed(2)) : null,
            checkerNm: checkerNm,
            checkTime: formatTime(new Date()),
            startTime: formatTime(checkStartTime),
            endTime: formatTime(checkEndTime),
            rm: rm,
            checkRsltDtls: checkRsltDtls,
            latitude: positionToUse.latitude ? String(positionToUse.latitude) : null,
            longitude: positionToUse.longitude ? String(positionToUse.longitude) : null
        };

        console.log('=== GPS 검증 최종 결과 ===', {
            shouldCheckGPS,
            errorCode: gpsStatus.errorCode,
            attemptCount: gpsStatus.attemptCount,
            validationResult: gpsValidationResult,
            currentPosition: positionToUse,
            facilityPosition,
            calculatedDistance: calculatedDistance !== null ? calculatedDistance.toFixed(2) + 'm' : 'null',
            finalGpsYn: insertCheckRsltRequest.gpsYn,
            finalGpsStatusCode: finalGpsStatusCode,
            reason: gpsValidationResult.success ? 'GPS 정상' : gpsValidationResult.reason
        });

        const groupCd = localStorage.getItem('groupCd');
        const userId = localStorage.getItem('userId');
        if (groupCd) insertCheckRsltRequest.groupCd = groupCd;
        if (userId) insertCheckRsltRequest.id = userId;

        formData.append('insertCheckRsltRequest', new Blob([JSON.stringify(insertCheckRsltRequest)], { type: 'application/json' }));

        if (filesWithoutPreview.length > 0) {
            filesWithoutPreview.forEach(file => {
                formData.append('uploadFiles', file);
            });
        }

        checkRsltDtls.forEach((detail, index) => {
            const detailFiles = detail.dtlUploadFiles;
            if (detailFiles && detailFiles.length > 0) {
                detailFiles.forEach(file => {
                    formData.append(`checkRsltDtls[${index}].dtlUploadFiles`, file);
                });
            }
        });

        try {
            const response = await axios.post(`${common.getApiUrl()}/checker`, formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    'Content-Type': 'multipart/form-data',
                },
            });

            // 성공 후 sessionStorage 정리
            sessionStorage.removeItem(`checkStarted_${facilityId}`);
            sessionStorage.removeItem(`checkStartTime_${facilityId}`);
            sessionStorage.removeItem(`useStrBtn_${facilityId}`);

            // 최종 알림 수정
            await new Promise(resolve => {
                if (insertCheckRsltRequest.gpsYn === 'N') {
                    if (finalGpsStatusCode === 'PERMISSION_DENIED') {
                        alert("GPS 권한이 거부되어 강제 등록되었습니다.\n점검결과가 등록되었습니다.");
                    } else if (finalGpsStatusCode === 'NO_SIGNAL') {
                        alert("GPS 신호를 받을 수 없어 강제 등록되었습니다.\n점검결과가 등록되었습니다.");
                    } else if (finalGpsStatusCode === 'OUT_OF_RANGE') {
                        // ⭐ 거리 초과 알림 수정
                        alert("거리검증 실패 (2/2)\n\n점검결과가 등록되었습니다.\n(시설물 반경 범위 초과)");
                    } else {
                        alert("GPS 검증 실패로 강제 등록되었습니다.\n점검결과가 등록되었습니다.");
                    }
                } else {
                    // ⭐ 정상 등록 알림 유지
                    alert("점검결과가 정상 등록되었습니다.");
                }
                resolve();
            });

            setGpsStatus({
                isReady: false,
                attemptCount: 0,
                loadingMessage: '',
                lastErrorType: null,
                errorCode: null
            });
            setIsSubmitting(false);
            navigate('/checker');

        } catch (error) {
            common.handleApiError(error);
            alert("점검 등록에 실패하였습니다.");
            setIsSubmitting(false);
        }
    };

    const groupByCheckTypeNm = (items) => {
        return items.reduce((acc, item) => {
            if (!acc[item.checkTypeNm]) {
                acc[item.checkTypeNm] = [];
            }
            acc[item.checkTypeNm].push(item);
            return acc;
        }, {});
    };

    const groupedItems = groupByCheckTypeNm(checkItems); //점검항목명 + 체크 세트

    const toggleExpand = (checkItemId) => {
        setExpandedItems(prev => ({
            ...prev,
            [checkItemId]: !prev[checkItemId],
        }));
    };

    // 모든 초기 로딩이 완료되었는지 확인
    const isAllInitialLoadingComplete = () => {
        return Object.values(initialLoadings).every(value => value === true);
    };

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: 'var(--main-white-color)'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                width: '100%',
                backgroundColor: 'var(--main-blue-color)',
                height: isScrolling ? '60px' : '160px',
                position: 'fixed',
                top: 0,
                zIndex: 1100,
                transition: 'height 0.2s ease',
            }}>
                {isQr === false ?
                    (<Box sx={{
                        position: 'absolute',
                        top: '20px',
                        left: '7px',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        backgroundColor: '#fff',
                        borderRadius: '15px',
                        padding: '0 2px 0 2px',
                        marginLeft: '0.5rem'
                    }}
                          onClick={() => navigate(-1)}
                    >
                        <IconButton sx={{ padding: '4px', paddingLeft: !isScrolling ? '10px' : '4px' }}>
                            <img src={leftArrowIcon} alt="뒤로가기" style={{ width: '15px', height: '15px' }} />
                        </IconButton>
                        {!isScrolling && (
                            <Typography sx={{ fontSize: '1.1rem', color: 'var(--main-blue-color)', paddingRight:'10px' }}>이전</Typography>
                        )}
                    </Box>)
                    :
                    (null)
                }
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    paddingTop: isScrolling ? '0px' : '10px',
                    transition: 'padding-top 0.3s ease',
                }}>
                    <Typography variant="h4" sx={{
                        fontSize: isScrolling ? '1.2rem' : '1.8rem',
                        transition: 'font-size 0.3s ease',
                        textAlign: 'center',
                        padding: '20px 30px 15px 30px', // 좌우 여백을 30px로 증가
                        maxWidth: '100%', // maxWidth 제한 제거
                        margin: '0 auto', // 중앙 정렬
                        // 멀티라인 허용하되 최대 2줄로 제한
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: 1.3,
                        // 단일 라인일 때는 nowrap, 긴 텍스트일 때는 wrap
                        wordBreak: 'keep-all', // 한글 단어 단위로 줄바꿈
                    }}>
                        {facilityName}
                    </Typography>
                </Box>
            </Box>
            <Container maxWidth="lg" sx={{
                padding: '0',
                flexGrow: 1,
                marginBottom: '10px',
                marginTop: isScrolling ? '120px' : '170px',
            }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    width: '100%',
                    padding: '0px 17px',
                    color: '#696969',
                    margin: '8px 0 14px 0'
                }}>
                    <Typography sx={{ fontSize: '0.9rem', }}>
                        작성일시 : {new Date().toLocaleString('ko-KR', {
                        timeZone: 'Asia/Seoul',
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    }).replace('.', '년 ').replace('.', '월 ').replace('.', '일 ').replace(/:.. /, ' ')}
                    </Typography>
                </Box>
                {gpsStatus.loadingMessage && (
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        padding: '8px 17px',
                        color: '#FF6B6B',
                        fontSize: '0.9rem',
                        fontWeight: 'bold'
                    }}>
                        📍 {gpsStatus.loadingMessage}
                    </Box>
                )}
                {/* 시작 버튼 - useStrBtn이 Y일 때만 표시 (수정 모드에서는 숨김) */}
                <Box sx={{
                    display: (useStrBtn === 'Y' && !checkRsltMstrId) ? 'flex' : 'none',
                    justifyContent: 'center',
                    width: '100%',
                    padding: '0 16px',
                    marginTop: '10px',
                    marginBottom: '15px',
                }}>
                    <Button
                        variant="contained"
                        size="large"
                        sx={{
                            width: '100%', // 버튼을 전체 너비로 확장
                            height: '60px',
                            fontSize: '1.5rem',
                            fontWeight: 'bold',
                            backgroundColor: isCheckStarted ? '#e0e0e0' : '#4C9AFF',
                            '&:hover': {
                                backgroundColor: isCheckStarted ? '#e0e0e0' : '#3A8AEF',
                            },
                            borderRadius: '10px',
                            boxShadow: 'none',
                            color: isCheckStarted ? '#999' : 'white',
                        }}
                        onClick={handleCheckStart}
                        disabled={isCheckStarted}
                    >
                        시작
                    </Button>
                </Box>
                {Object.entries(groupedItems).length === 0 && (
                    <Box sx={{
                        mt: 2,
                        p: 2,
                        borderRadius: '4px',
                        boxShadow: 'none'
                    }}>
                        <Typography variant="body1" align="center">
                            점검 항목이 없습니다.
                        </Typography>
                    </Box>
                )}
                {Object.entries(groupedItems).map(([checkTypeNm, items]) => (
                    <Box key={checkTypeNm} sx={{ overflow: 'visible' }}>
                        {Object.entries(groupedItems).length > 0 && (
                            <TableContainer
                                component={Paper}
                                sx={{
                                    //mt: 2,
                                    mb: 2,
                                    pt: 1,
                                    pr: 1,
                                    pl: 1,
                                    overflow: 'visible',
                                    borderRadius: '18px',
                                    boxShadow: 'none',
                                }}
                            >
                                <Box sx={{
                                    padding: '5px',
                                    paddingLeft: '10px',
                                    marginBottom: '10px',
                                }}>
                                    {/* 점검유형명 */}
                                    <Typography variant="h5"
                                                sx={{ fontWeight: 'bold', fontSize: '1.6rem' }}>
                                        {checkTypeNm}
                                    </Typography>
                                </Box>
                                <Table>
                                    {items.find(item => item.textYn == 'N') ? (
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ borderBottom: '1px solid #696969' }}></TableCell>
                                                <TableCell sx={{ padding: 0, borderBottom: '1px solid #696969' }}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        padding: '0',
                                                        justifyContent: 'space-between',
                                                    }}>
                                                        {checkStateList.map((state) => (
                                                            <Box key={state.checkStateId} sx={{ textAlign: 'center', flex: '1' }}>
                                                                <Typography variant="body2"
                                                                            sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                                                    {state.checkStateNm}
                                                                </Typography>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                </TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #696969', padding: '0' }}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                    ) : null}

                                    <TableBody sx={{ borderTop: '1px solid #696969' }}>
                                        {items.length > 0 ? (
                                            items.map((item, index) => {
                                                const isLastItem = index === items.length - 1;
                                                const isExpanded = expandedItems[item.checkItemId];
                                                return (
                                                    <React.Fragment key={item.checkItemId}>
                                                        <TableRow key={`row-${item.checkItemId}`}>
                                                            <TableCell component="th" scope="row" ref={cellRef}
                                                                       sx={{
                                                                           fontSize: '1.1rem',
                                                                           paddingX: '2px',
                                                                           textAlign: 'left',
                                                                           width: '40%',
                                                                           paddingLeft: '10px'
                                                                       }}>
                                                                <span>{item.checkItemNm}</span>
                                                            </TableCell>
                                                            <TableCell align="center" sx={{
                                                                paddingX: '0px',
                                                                pt: '5px',
                                                                pb: '5px',
                                                                position: 'relative'
                                                            }}>
                                                                {item.textYn === "Y" ? (
                                                                    <TextField
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        size="small"
                                                                        autoComplete="off"
                                                                        value={selectedState[item.checkItemId] || ""}
                                                                        onChange={handleTextChange(item.checkItemId)}
                                                                        disabled={!isFormEnabled()}
                                                                        sx={{ paddingRight: 2 }}
                                                                    />
                                                                ) : (
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        width: '100%',
                                                                    }}>
                                                                        {checkStateList.map(state => (
                                                                            <Box key={state.checkStateId}
                                                                                 sx={{
                                                                                     flex: '1',
                                                                                     display: 'flex',
                                                                                     justifyContent: 'center'
                                                                                 }}>
                                                                                <Radio
                                                                                    checked={selectedState[item.checkItemId] === state.checkStateNm}
                                                                                    onChange={handleRadioChange(item.checkItemId)}
                                                                                    value={state.checkStateNm || ''}
                                                                                    name={item.checkItemId + '-radio'}
                                                                                    disabled={!isFormEnabled()}
                                                                                    sx={{
                                                                                        transform: 'scale(0.8)',
                                                                                        '&.Mui-checked': {
                                                                                            color: '#1C6DFF',  // 체크된 상태 색상
                                                                                            '& .MuiSvgIcon-root': { // 체크된 상태일 때의 아이콘
                                                                                                backgroundColor: '#1C6DFF',
                                                                                                borderRadius: '50%',
                                                                                                color: '#1C6DFF',
                                                                                            }
                                                                                        },
                                                                                        '& .MuiSvgIcon-root': {
                                                                                            fontSize: '1.5rem',
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </Box>
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ paddingX: '0px' }}>
                                                                {!isExpanded && (
                                                                    <Box sx={{
                                                                        height: '25px',
                                                                        width: '25px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                        marginLeft: 'auto', // 오른쪽 끝으로 배치
                                                                        justifyContent: 'center',
                                                                    }} onClick={() => toggleExpand(item.checkItemId)}>
                                                                        <img
                                                                            src={iconEdit}
                                                                            alt="edit"
                                                                            style={{
                                                                                width: '18px',
                                                                                height: '18px',
                                                                                objectFit: 'contain',
                                                                                filter: 'invert(37%) sepia(97%) saturate(1728%) hue-rotate(213deg) brightness(101%) contrast(107%) drop-shadow(0px 0px 0.5px #1C6DFF)',  // 원래 필터에 drop-shadow 추가
                                                                                WebkitFilter: 'invert(37%) sepia(97%) saturate(1728%) hue-rotate(213deg) brightness(101%) contrast(107%) drop-shadow(0px 0px 0.5px #1C6DFF)',  // Safari 지원
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                        {isExpanded && (
                                                            <TableRow key={`expanded-${item.checkItemId}`}>
                                                                <TableCell colSpan={3} sx={{
                                                                    padding: '10px 10px 20px 10px',
                                                                    position: 'relative',
                                                                    maxWidth: '100vw',
                                                                    overflowX: 'hidden'
                                                                }}>
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        width: '100%'
                                                                    }}>
                                                                        {/* 입력 필드와 버튼을 포함하는 상단 영역 */}
                                                                        <Box sx={{
                                                                            display: 'flex',
                                                                            width: '100%',
                                                                            marginBottom: '10px'
                                                                        }}>
                                                                            <TextField
                                                                                fullWidth
                                                                                variant="outlined"
                                                                                size="small"
                                                                                multiline
                                                                                rows={2}
                                                                                autoComplete="off"
                                                                                placeholder="특이사항을 입력하세요."
                                                                                value={selectedState[`rm_${item.checkItemId}`] || ""}
                                                                                onChange={(e) => setSelectedState(prev => ({
                                                                                    ...prev,
                                                                                    [`rm_${item.checkItemId}`]: e.target.value
                                                                                }))}
                                                                                disabled={!isFormEnabled()} // 점검 시작 전에는 비활성화
                                                                                sx={{ width: '75%', paddingRight: 1 }}
                                                                            />
                                                                            <Button
                                                                                variant="contained"
                                                                                component="label"
                                                                                sx={{ width: '25%' }}
                                                                            >
                                                                                사진 첨부
                                                                                <input
                                                                                    type="file"
                                                                                    accept="image/*"
                                                                                    multiple
                                                                                    hidden
                                                                                    onChange={(e) => handleEachStateImgUpload(item, e)}
                                                                                />
                                                                            </Button>
                                                                        </Box>

                                                                        {/* 이미지 미리보기 영역 */}
                                                                        <Box sx={{
                                                                            width: '100%',
                                                                            overflowX: 'auto',
                                                                            WebkitOverflowScrolling: 'touch',
                                                                            '&::-webkit-scrollbar': {
                                                                                display: 'none'
                                                                            },
                                                                            msOverflowStyle: 'none',
                                                                            scrollbarWidth: 'none'
                                                                        }}>
                                                                            <Box sx={{
                                                                                display: 'flex',
                                                                                gap: '15px',
                                                                                paddingBottom: '10px'
                                                                            }}>
                                                                                {selectedState[`filePreviews_${item.checkItemId}`]?.map((fileObj, index) => (
                                                                                    <Box
                                                                                        key={`preview-${item.checkItemId}-${index}`}
                                                                                        sx={{
                                                                                            position: 'relative',
                                                                                            width: '150px',
                                                                                            marginBottom: '10px'
                                                                                        }}
                                                                                    >
                                                                                        {fileObj.file.type.startsWith('image/') && (
                                                                                            <img
                                                                                                src={fileObj.preview}
                                                                                                alt="미리보기"
                                                                                                style={{
                                                                                                    width: '150px',
                                                                                                    height: 'auto'
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                        <Button
                                                                                            onClick={() => handleEachStateImgRemove(item, index)}
                                                                                            sx={{
                                                                                                position: 'absolute',
                                                                                                top: '5px',
                                                                                                right: '5px',
                                                                                                minWidth: 'auto',
                                                                                                padding: '2px 8px',
                                                                                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                                                                                color: 'red',
                                                                                                '&:hover': {
                                                                                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            삭제
                                                                                        </Button>
                                                                                    </Box>
                                                                                ))}
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>

                                                                    <Box sx={{
                                                                        position: 'absolute',
                                                                        bottom: '0px',
                                                                        right: '0px',
                                                                        backgroundColor: '#fff',
                                                                        border: '1px solid #ddd',
                                                                        width: '25px',
                                                                        height: '25px',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer'
                                                                    }} onClick={() => toggleExpand(item.checkItemId)}>
                                                                        <RemoveIcon sx={{ color: '#57A6E4', fontSize: '17px' }} />
                                                                    </Box>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })
                                        ) : (
                                            <Box sx={{
                                                mt: 2,
                                                p: 2,
                                                borderRadius: '4px',
                                                boxShadow: 'none'
                                            }}>
                                                <Typography variant="body1" align="center">
                                                    점검 항목이 없습니다.
                                                </Typography>
                                            </Box>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>
                ))}
                {/* 점검자 섹션 */}
                <Box
                    component={Paper}
                    sx={{
                        p: '10px 20px',
                        height: '70px',
                        mt: 2,
                        borderRadius: '18px',
                        boxShadow: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                    }}
                >
                    <Box sx={{ width: '30%' }}>점검자</Box>
                    <Box sx={{ width: '70%' }}>
                        <TextField
                            variant="outlined"
                            value={checkerNm}
                            onChange={(e) => setCheckerNm(e.target.value)}
                            fullWidth
                            placeholder="이름을 입력하세요."
                            sx={{
                                backgroundColor: '#F5F5F5',
                                borderRadius: '25px',
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        border: 'none',
                                    },
                                    '&:hover fieldset': {
                                        border: 'none',
                                    },
                                    '&.Mui-focused fieldset': {
                                        border: 'none',
                                    },
                                },
                                '& .MuiInputBase-input::placeholder': {
                                    color: '#1C6DFF',
                                    opacity: 1,
                                },
                            }}
                        />
                    </Box>
                </Box>

                {/* 비고 섹션 */}
                <Box
                    component={Paper}
                    sx={{
                        p: '10px 20px',
                        minHeight: '70px',
                        mt: 2,
                        borderRadius: '18px',
                        boxShadow: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                    }}
                >
                    <Box sx={{ width: '30%' }}>비고</Box>
                    <Box sx={{ width: '70%' }}>
                        <TextField
                            variant="outlined"
                            value={rm}
                            onChange={(e) => setRm(e.target.value)}
                            fullWidth
                            multiline
                            rows={2}
                            placeholder="비고 사항을 입력하세요."
                            sx={{
                                backgroundColor: '#F5F5F5',
                                borderRadius: '15px',
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        border: 'none',
                                    },
                                    '&:hover fieldset': {
                                        border: 'none',
                                    },
                                    '&.Mui-focused fieldset': {
                                        border: 'none',
                                    },
                                },
                                '& .MuiInputBase-input::placeholder': {
                                    color: '#1C6DFF',
                                    opacity: 1,
                                },
                            }}
                        />
                    </Box>
                </Box>

                {/* 파일 업로드 섹션 */}
                <Box
                    component={Paper}
                    sx={{
                        p: '10px 20px',
                        minHeight: '70px',
                        mt: 2,
                        mb: '15vh',
                        borderRadius: '18px',
                        boxShadow: 'none',
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        width: '100%',
                    }}>
                        <Box sx={{ width: '30%' }}>파일 업로드</Box>
                        <Box sx={{ width: '70%' }}>
                            <Button
                                variant="contained"
                                component="label"
                                sx={{
                                    borderRadius: '20px',
                                    padding: '10px 30px',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        boxShadow: 'none',
                                    },
                                    '&:active': {
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                파일 선택
                                <input
                                    type="file"
                                    accept="image/*, video/*"
                                    multiple
                                    hidden
                                    onChange={handleFileUpload}
                                />
                            </Button>
                        </Box>
                    </Box>

                    {/* 파일 미리보기 영역 */}
                    <Box sx={{
                        marginTop: '10px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '15px',
                        width: '100%',
                    }}>
                        {files.map((fileObj, index) => (
                            <Box
                                key={`file-${index}-${fileObj.preview}`}
                                sx={{
                                    position: 'relative',
                                    width: '150px',
                                    marginBottom: '10px'
                                }}
                            >
                                {fileObj.file.type.startsWith('image/') && (
                                    <img
                                        src={fileObj.preview}
                                        alt="미리보기"
                                        style={{
                                            width: '150px',
                                            height: 'auto'
                                        }}
                                    />
                                )}
                                {fileObj.file.type.startsWith('video/') && (
                                    <video
                                        src={fileObj.preview}
                                        width="150"
                                        height="auto"
                                        controls
                                    />
                                )}
                                <Button
                                    onClick={() => handleFileRemove(index)}
                                    sx={{
                                        position: 'absolute',
                                        top: '5px',
                                        right: '5px',
                                        minWidth: 'auto',
                                        padding: '2px 8px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                        color: 'red',
                                        '&:hover': {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        }
                                    }}
                                >
                                    삭제
                                </Button>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>
            {Object.keys(groupedItems).length > 0 && (
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        width: '100%',
                        py: 2,
                        //backgroundColor: '#fff',
                        backgroundColor: 'transparent', // 배경색을 투명하게 변경
                        display: 'flex',
                        justifyContent: 'center',
                        left: 0,
                        px: '20px',
                        boxSizing: 'border-box',
                        zIndex: 1300,
                    }}
                >
                    <Button
                        id="submitButton"
                        variant="contained"
                        size="large"
                        fullWidth
                        sx={{
                            minHeight: '8vh',
                            maxWidth: '600px',
                            fontSize: '2.0rem',
                            boxShadow: 'none',
                            borderRadius: '35px',
                            bgcolor: checkEndTime ? 'var(--main-blue-color)' : '#e0e0e0',
                            '&.Mui-disabled': {
                                backgroundColor: '#e0e0e0',
                                color: '#999'
                            }
                        }}
                        disabled={
                            !areAllItemsChecked() ||
                            (!checkRsltMstrId && useStrBtn === 'Y' && !isCheckStarted) ||
                            isSubmitting
                        }
                        onClick={submitResults}
                    >
                        {isSubmitting ? (checkRsltMstrId ? '수정 중...' : '등록 중...') : (checkRsltMstrId ? '수정완료' : '작성완료')}
                    </Button>
                </Box>
            )}
        </Box>
    );
}

export default validationAuth(RegisterCheck);